import { useEffect, useState } from 'react';
import { ordersApi, type Order } from '../../api/orders';

export function SLADashboardPage() {
  const [orders, setOrders] = useState<Order[]>([]);

  useEffect(() => {
    void ordersApi.list().then((list) => setOrders(list.filter((o) => o.sla_breached)));
  }, []);

  return (
    <div className="mx-auto max-w-4xl p-6">
      <h1 className="text-2xl font-semibold">SLA Dashboard</h1>
      <p className="mt-1 text-sm text-slate-600">Orders with breached SLAs.</p>
      <ul className="mt-6 space-y-2">
        {orders.map((o) => (
          <li key={o.id} className="rounded border border-red-200 bg-red-50 p-3 text-sm">{o.order_number} — health {o.health_score}</li>
        ))}
        {orders.length === 0 && <p className="text-slate-500">No SLA breaches.</p>}
      </ul>
    </div>
  );
}
